export default {
  label: {
    sk: 'Preskočiť na hlavný obsah',
    en: 'Skip to main content',
  },
};



// WEBPACK FOOTER //
// ./src/modules/SkipToContentButton/messages.js